export default "/images/abweb-logo.svg?73b4be6c5c9fceaca7b90ef4af8d4a76";